// skills-future.js
document.addEventListener("DOMContentLoaded", function () {
    console.log('Skills Future script loaded');

    // const button = document.getElementById('skillsfutureapibutton'); // No '#' for id
    // if (button) {
    //     button.addEventListener('click', function () {
    //         console.log('skillsfutureapibutton Button clicked');
    //         // Call the function
    //         postSkillFutureEncryptRequest();
    //     });
    // } else {
    //     console.error('Button with id "skillsfutureapi" not found');
    // }
});

async function postSkillFutureEncryptRequest() {
    const url = "https://fz9ic212ck.execute-api.ap-southeast-1.amazonaws.com/api/skillfuture/encryptRequests";

    const headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        // "x-api-version": "v2",
        // "X-Api-Signature": "GHHF15H4FbCyRtwmQcZ........HRvo8FW5u7yNHVQapQM4a4DQ=="
    };

    const body = {
        claimRequest: {
            course: {
                id: "TGS-20241218",
                fee: "100.00",
                runId: "C123",
                startDate: "2024-12-18"
            },
            individual: {
                nric: "T5001072J",
                email: "someone@example.com",
                homeNumber: "87654321",
                mobileNumber: "98760000"
            },
            additionalInformation: "fs"
        }
    };

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Response data:", data);

        const decryptUrl = "https://fz9ic212ck.execute-api.ap-southeast-1.amazonaws.com/api/skillfuture/decryptRequests";
        console.log('data', data);
        console.log('data.claimRequest', data.data.claimRequest);
        decryptRequest(decryptUrl, data.data.claimRequest)
            .then(response => {
                console.log("Decrypted data:", response);
                return response;
            }).then((resp) => {
                // If success, create a discount voucher and attach it to the order
                console.log('resp', resp);
                alert('Claim success for amount: ' + resp.data.claim.amount);
                return resp;
            })
            .catch(error => {
                console.error("API call failed:", error);
            });
    } catch (error) {
        console.error("Error making API call:", error);
    }
}

async function decryptRequest(apiUrl, requestBody) {
    try {
        // Define the API URL
        const url = apiUrl;

        // Define the request headers
        const headers = {
            "Accept": "application/json",
            "Content-Type": "application/json",
            // "x-api-version": "v2"
        };

        // Make the POST request using fetch
        const response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(requestBody)
        });

        // Check if the response is OK
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Parse the JSON response
        const data = await response.json();
        console.log("Response1 data:", data);

        return data;
    } catch (error) {
        console.error("Error making API request:", error);
        throw error;
    }
}






